import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=5ff4b493&scoped=true"
import script from "./base-modal.vue?vue&type=script&lang=js"
export * from "./base-modal.vue?vue&type=script&lang=js"
import style0 from "./base-modal.vue?vue&type=style&index=0&id=5ff4b493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4b493",
  null
  
)

export default component.exports